import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { useRecordContext } from "react-admin";
import { firebaseApp } from "../firebase";
import { StripeIcon } from "../icons/StripeIcon";
import { Student } from "../providers/studentsProvider";

export function OpenInStripeMenuItem(props: { closeMenu: () => void }) {
  const { closeMenu } = props;
  const { projectId } = firebaseApp.options;
  const student = useRecordContext<Student>();
  const { stripeCustomerId } = student;
  if (!stripeCustomerId) return null;
  const stripeBaseUrl = `https://dashboard.stripe.com/${projectId !== "autovio-prod" ? "test/" : ""}`;
  const url = `${stripeBaseUrl}customers/${stripeCustomerId}`;
  return (
    <MenuItem
      onClick={() => {
        closeMenu();
        open(url, "_blank");
      }}
    >
      <ListItemIcon>
        <StripeIcon sx={{ fontSize: 20 }} />
      </ListItemIcon>
      <ListItemText>In Stripe öffnen</ListItemText>
    </MenuItem>
  );
}
